<template>
<div>
  <main-header-nav
    :goBack="goBack"
    :title="'工程分部列表'"
    :content="'新建工程分部'">
  </main-header-nav>
  <el-card v-loading="loading" style="width: 500px;margin: 30px auto;padding: 30px 10px 10px 10px;">
    <project-item-form
      :type="type"
      :form="editForm"
      :rules="rules"
      :projectItems="projectItems"
    >
    </project-item-form>
  </el-card>
</div>
</template>
<script>
import ProjectItemForm from './ProjectItemForm'
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  name: 'AddProjectItem',

  components: {
    ProjectItemForm, MainHeaderNav
  },

  data () {
    return {
      type: 'edit',
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      },
      editForm: {
        name: '',
        parentItem: {}
      },
      loading: false,
      projectItems: []
    }
  },

  mounted () {
    var self = this
    this.$data.loading = true
    this.getRequest('/project_items')
      .then(resp => {
        if (resp && resp.result) {
          var projectItems = resp.result
          for (var i = 0; i < projectItems.length; i++) {
            var parentItem = projectItems[i].parentItem
            while (parentItem != null) {
              projectItems[i].name =
              parentItem.name + '/' + projectItems[i].name
              parentItem = parentItem.parentItem
            }
          }
          self.$data.projectItems = projectItems
          self.getRequest('/project_items/' + self.$route.params.id)
            .then(resp => {
              if (resp && resp.result) {
                self.$data.loading = false
                self.$data.editForm = resp.result
              }
            })
        }
      })
  },

  methods: {
    goBack () {
      this.$router.replace('/project_items')
    }
  }
}
</script>
<style></style>
